import HomepageApp from './Homepage';

export default HomepageApp;
